import { useEffect } from 'react';

import { checkoutAPIService } from '~/api/checkout';
import { logger } from '~/utils/logger';

function CancelSubscription() {
  const handleCancelSubscription = async () => {
    try {
      const response = await checkoutAPIService.cancelSubscription();

      window.location.href = response?.data?.url;
    } catch (e) {
      logger.error(e);
    }
  };

  useEffect(() => {
    handleCancelSubscription();
  }, []);

  return null;
}

export default CancelSubscription;
